import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/categories';
import './CategoriesSection.css';

const CategoriesSection = () => {
    return (
        <div className="categories-section">
            <div className="home-section-header">
                <h2 className="section-title">Shop by Category</h2>
            </div>

            <div className="categories-container">
                {categories.map((category) => (
                    <Link
                        key={category.id}
                        to={`/category/${category.slug}`}
                        className="category-card"
                    >
                        <div className="category-image-wrapper">
                            <img
                                src={category.image}
                                alt={category.name}
                                className="category-image"
                                loading="lazy"
                                decoding="async"
                            />
                            <div className="category-overlay"></div>
                        </div>
                        <div className="category-content">
                            <span className="category-name">{category.name}</span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default CategoriesSection;
